import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-record",
  "use": "icon-record-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-record\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,18a2,2,0,1,1,2-2A2,2,0,0,1,12,18Zm4-4a2,2,0,1,1,2-2A2,2,0,0,1,16,14ZM8,14a2,2,0,1,1,2-2A2,2,0,0,1,8,14Zm4-4a2,2,0,1,1,2-2A2,2,0,0,1,12,10Zm0,10h8v2H12a10,10,0,1,1,8-4H17.29A8,8,0,1,0,12,20Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol